// components/main/ObjektErstellenForm.jsx

import React, { useState } from "react";
import { useNavigate } from "react-router";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from "react-datepicker";
import de from "date-fns/locale/de";
registerLocale("de", de);

const ObjektErstellenForm = ({
  handleSubmit,
  handleChange,
  handleImageChange,
  formData,
  errorMessage,
  kategorienData,
  ablageorteData,
  typenData,
  laenderData,
  materialienData,
  waehrungenData,
  zustaendeData,
  eigentuemerData
}) => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("basis");

    const renderInput = (label, name, type = "text") => (
      <div className="col-md-4">
        <label htmlFor={name} className="form-label">{label}</label>
        <input
          id={name}
          type={type}
          name={name}
          value={formData[name] || ""}
          onChange={handleChange}
          className="form-control"
        />
      </div>
    );

    const renderSelect = (label, name, options) => (
      <div className="col-md-4">
        <label htmlFor={name} className="form-label">{label}</label>
        <select
          id={name}
          name={name}
          value={formData[name] || ""}
          onChange={handleChange}
          className="form-select"
        >
          <option value="">Bitte wählen</option>
          {(options || []).map((opt) => (
            <option key={opt.id} value={opt.id}>
              {opt.vorname ? `${opt.vorname}${opt.name ? ' ' + opt.name : ''}` : opt.name}
            </option>
          ))}
        </select>
      </div>
    );

  const renderDatePicker = (label, name) => (
    <div className="col-md-4">
      <label className="form-label">{label}</label>
      <div className="input-group">
        <DatePicker
          selected={formData[name] ? new Date(formData[name]) : null}
          onChange={(date) => handleChange({ target: { name, value: date } })}
          dateFormat="dd.MM.yyyy"
          placeholderText="dd.mm.yyyy"
          locale="de"
          className="form-control w-100"
          wrapperClassName="w-100"
        />
      </div>
    </div>
  );

  const TabButton = ({ id, label }) => (
    <li className="nav-item" role="presentation">
      <button
        className={`nav-link ${activeTab === id ? "active" : ""}`}
        onClick={() => setActiveTab(id)}
        type="button"
        role="tab"
      >
        {label}
      </button>
    </li>
  );

  // check, if category "Münzen" is selected
  const selectedKategorie = kategorienData.find(k => k.id === parseInt(formData.kategorie));
  const isMuenzeKategorie = ["Münze", "Münzen"].includes(selectedKategorie?.name);

  return (
    <form onSubmit={handleSubmit} className="container mt-4">
      <div className="card shadow-sm">
        <div className="card-body">
          <h3 className="card-title mb-4">Neue Münze erfassen</h3>

          <ul className="nav nav-tabs mb-3" role="tablist">
            <TabButton id="basis" label="Basisdaten" />
            <TabButton id="erweitert" label="Erweiterte Daten" />
            <TabButton id="kommentare" label="Kommentare" />
            <TabButton id="bilder" label="Bilder" />
          </ul>

          <div className="tab-content">
            {activeTab === "basis" && (
              <div className="row g-3">
                {renderSelect("Kategorie", "kategorie", kategorienData)}
                {renderSelect("Land", "land", laenderData)}
                {renderSelect("Währung", "waehrung", waehrungenData)}
                {renderInput("Nominalwert", "nominalwert", "number")}
                {renderInput("Jahrgang", "jahrgang")}
                {renderInput("Jahrgang Zusatz", "jahrgangZusatz")}
                {isMuenzeKategorie && renderSelect("Typ", "typ", typenData)}
                {isMuenzeKategorie && renderSelect("Material", "material", materialienData)}
                <div className="col-12">
                  <label className="form-label">Beschreibung</label>
                  <textarea
                    className="form-control"
                    name="beschreibung"
                    value={formData.beschreibung || ""}
                    onChange={handleChange}
                    rows={3}
                  />
                </div>
              </div>
            )}

            {activeTab === "erweitert" && (
              <div className="row g-3">
                {renderInput("Sammlerwert", "sammlerwert", "number")}
                {renderInput("Anzahl", "anzahl", "number")}
                {renderSelect("Zustand", "zustand", zustaendeData)}
                {renderSelect("Eigentümer", "eigentuemer", eigentuemerData)}
                {renderSelect("Ablageort", "ablageort", ablageorteData)}
                {/*{renderInput("Kaufdatum", "kaufdatum", "date")}*/}
                {renderDatePicker("Kaufdatum", "kaufdatum")}
                {renderInput("Kaufpreis", "kaufpreis", "number")}
                {/*{renderInput("Verkaufsdatum", "verkaufsdatum", "date")}*/}
                {renderDatePicker("Verkaufsdatum", "verkaufsdatum")}
                {renderInput("Verkaufspreis", "verkaufspreis", "number")}
                <div className="col-md-4">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      name="status_reinigung_offen"
                      checked={formData.status_reinigung_offen || false}
                      onChange={(e) =>
                        handleChange({
                          target: {
                            name: "status_reinigung_offen",
                            value: e.target.checked
                          }
                        })
                      }
                    />
                    <label className="form-check-label">Reinigung offen</label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      name="status_sammlung"
                      checked={formData.status_sammlung || false}
                      onChange={(e) =>
                        handleChange({
                          target: {
                            name: "status_sammlung",
                            value: e.target.checked
                          }
                        })
                      }
                    />
                    <label className="form-check-label">In Sammlung</label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      name="status_gesucht"
                      checked={formData.status_gesucht || false}
                      onChange={(e) =>
                        handleChange({
                          target: {
                            name: "status_gesucht",
                            value: e.target.checked
                          }
                        })
                      }
                    />
                    <label className="form-check-label">Gesucht</label>
                  </div>
                </div>
                  {formData.status_gesucht && (
                    <>
                      {renderInput("Wunschpreis", "wunschpreis", "number")}
                      {renderSelect("Wunschzustand", "wunschzustand", [])}
                    </>
                  )}
              </div>
            )}

            {activeTab === "kommentare" && (
              <div className="mb-3">
                <label className="form-label">Kommentare</label>
                <textarea
                  className="form-control"
                  name="kommentare"
                  value={formData.kommentare || ""}
                  onChange={handleChange}
                  rows={5}
                />
              </div>
            )}

            {activeTab === "bilder" && (
              <div className="row g-3">
                <div className="col-md-6">
                  <label className="form-label"></label>
                  <input
                    type="file"
                    name="bild01"
                    accept="image/*"
                    onChange={(e) => handleImageChange("bild01", e.target.files[0])}
                    className="form-control"
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label"></label>
                  <input
                    type="file"
                    name="bild02"
                    accept="image/*"
                    onChange={(e) => handleImageChange("bild02", e.target.files[0])}
                    className="form-control"
                  />
                </div>
              </div>
            )}
          </div>

          {errorMessage && (
            <div className="alert alert-danger mt-4" role="alert">
              ⚠️ {errorMessage}
            </div>
          )}

          <div className="mt-4 d-flex gap-2">
            <button type="button" className="btn btn-secondary" onClick={() => navigate("/objekte")}>
              Zurück
            </button>
            <button type="submit" className="btn btn-primary">
              Speichern
            </button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default ObjektErstellenForm;
